import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { INzMessageType } from '@ascschool/interface/setting';
import { ForgotPasswordService } from '@ascschool/services/user/forgot-password.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { da } from 'date-fns/locale';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
@Component({
    selector: 'app-reset-mat-khau',
    templateUrl: './reset-mat-khau.component.html',
    styleUrls: ['./reset-mat-khau.component.scss']
})
export class ResetMatKhauComponent implements OnInit {
    tokken: string;
    email: string;
    validateForm = new FormGroup({
        userName: new FormControl('', Validators.required),
        email: new FormControl('', Validators.required)
    });

    getUserACFn: (value: any) => Observable<any>; userSubscription: any; userControl = new FormControl();
    constructor(private fb: FormBuilder,
        private service: ForgotPasswordService,
        private utilsService: UtilsService,
        protected router: Router,
    ) { }

    ngOnInit() {
    }

    Submit() {
        this.service.get(this.validateForm.value).subscribe(data => {
            if (data.statusCode === 0) {
                this.router.navigateByUrl(`/xacnhan?token=${data.data.token}`);
                this.utilsService.showNotification(INzMessageType.Success, "Xác thực thành công", 3000);
            } else {
                this.utilsService.showNotification(INzMessageType.Error, data.message, 3000);
            }
        })
    }

    loadUser() {
        this.getUserACFn = (value: any) => this.service.getUsernamesByEmail({ email: this.email }).pipe(
            map(resp => resp.length > 0 ? resp.map(x => ({ id: x.id, text: x.userName })) : [{ id: null, text: 'Không có dữ liệu' }])
        );
        // if (!this.userSubscription) {
        //   this.userSubscription = this.userControl.valueChanges.subscribe(() => {
        //     this.utilsService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.userControl.value);
        //   });
        // }
    }

    changeUser(control: FormControl) {
        if (control.value) {
            this.userControl = control;
            this.validateForm.get('userName').setValue(control.value.text);
        }
    }

    onKeyUp(event) {
        this.email = event.target.value;
        if (event) {
            this.loadUser();
        }
    }

}
